import { render, staticRenderFns } from "./Identicon.vue?vue&type=template&id=9bb0e158&lang=pug&"
import script from "./Identicon.vue?vue&type=script&lang=js&"
export * from "./Identicon.vue?vue&type=script&lang=js&"
import style0 from "./Identicon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports